export default function union(...others) {
  const set = new Set();
  for (const other of others) {
    for (const o of other) {
      set.add(o);
    }
  }
  return set;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-array/src/union.js
// module id = null
// module chunks = 